export type MembershipAddOnForDisplay = {
  id: string;
  code: string;
  name: string;
  description: string;
  annualAmountInDollars: number | null;
  // No tax on this add-on (Chamber Set Up). Absent on legacy add-ons.
  taxExempt?: boolean | null;
};

type AddOnSource = MembershipAddOnForDisplay & { enabled: boolean };

// Update Member Step 5 (view only): every enabled configured add-on, plus
// saved selections that were later removed from settings. A percentage
// add-on has a different amount per membership (design (11)), so the
// member's own membership is read first.
export const getDisplayedMembershipAddOns = ({
  legacyDescription,
  membershipModels,
  membershipTypeId,
  selectedAdditionalCostIds,
}: {
  legacyDescription: string;
  membershipModels: Array<{ id: string; additionalCosts: AddOnSource[] }>;
  membershipTypeId?: string | null;
  selectedAdditionalCostIds: string[];
}): MembershipAddOnForDisplay[] => {
  const addOnsById = new Map<string, MembershipAddOnForDisplay>();
  const memberMembershipModel = membershipModels.find(
    (model) => model.id === membershipTypeId
  );
  const configuredAddOns = [
    ...(memberMembershipModel?.additionalCosts || []),
    ...membershipModels.flatMap((model) => model.additionalCosts),
  ];

  configuredAddOns
    .filter((cost) => cost.enabled)
    .forEach((cost) => {
      if (!addOnsById.has(cost.id)) {
        addOnsById.set(cost.id, cost);
      }
    });

  selectedAdditionalCostIds.forEach((additionalCostId) => {
    if (addOnsById.has(additionalCostId)) {
      return;
    }
    const configuredAddOn = configuredAddOns.find(
      (cost) => cost.id === additionalCostId
    );
    addOnsById.set(
      additionalCostId,
      configuredAddOn || {
        id: additionalCostId,
        code: additionalCostId,
        name: "Legacy add-on benefit",
        description: legacyDescription,
        annualAmountInDollars: null,
      }
    );
  });

  return Array.from(addOnsById.values());
};
